import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Api from 'services/Api'
import { smsSegmenter } from 'services/Utilities'
import { createErrorNotification, createNotification } from 'store/actions/notifications'
import { closeModal } from 'store/actions/modals'
import BaseModal from 'components/Modals/BaseModal'
import { Button } from 'components/Forms'
import { ScrollableUserList, CostIcon } from 'components/UI'
import { Card, Checkbox } from 'ui'

import { t } from 'translations'

const BulletinSendNotificationsModal = ({ _id, content, smsContent, onBeforeClose }) => {
  const dispatch = useDispatch()
  const { disableTwilio } = useSelector(state => state.settings)

  const [users, setUsers] = useState([])
  const [creditToUse, setCreditToUse] = useState()
  const [isSending, setIsSending] = useState()
  const [sendSms, setSendSms] = useState(false)
  const [sendEmail, setSendEmail] = useState(!!content)

  useEffect(() => {
    async function fetchNotificationCount() {
      const { count, result, success } = await Api(`/contact/bulletin/${_id}/notifications/count`)
      if (!success) return dispatch(createErrorNotification())
      const creditPerMessage = smsSegmenter.auto(smsContent).length
      setUsers(result)
      setCreditToUse(count * creditPerMessage)
    }
    fetchNotificationCount()
  }, [_id, dispatch, smsContent])

  async function send() {
    setIsSending(true)
    const { success } = await Api.post(`/contact/bulletin/${_id}/notifications`, { sendSms, sendEmail })
    if (!success) return dispatch(createErrorNotification())
    // Reload the bulletins
    onBeforeClose()
    dispatch(createNotification({ description: 'manager.bulletins.BULLETIN_SENT_DESC', icon: 'bullhorn', title: 'manager.bulletins.BULLETIN_SENT' }))
    dispatch(closeModal())
  }

  return (
    <BaseModal hideButtons title={`manager.bulletins.SEND_NOTIFICATIONS_MODAL`} summaryVar={{ amount: users.length }}>
      <ScrollableUserList usersIds={users} />

      {/* Hide all sending options if twilio is disabled for now, if we add more options than email in the future we can show this section with twilio disabled */}
      {!disableTwilio ? (
        <Card maxHeight="10rem" className="bg-light mb-3">
          <Card.Body>
            <div className="form-group form-check">
              <Checkbox id="sendEmail" value={sendEmail} checked={sendEmail} onChange={() => setSendEmail(!sendEmail)} disabled={!content} />
              <label className="form-check-label" htmlFor="sendEmail">
                {t('manager.bulletins.SEND_BY_EMAIL')}
              </label>
              {!content ? <small className="form-text text-warning">{t('manager.bulletins.NO_EMAIL_VERSION')}</small> : null}
            </div>
            <div className="form-group form-check">
              <Checkbox id="sendSms" value={sendSms} checked={sendSms} onChange={() => setSendSms(!sendSms)} disabled={!smsContent} />
              <label className="form-check-label" htmlFor="sendSms">
                {t('manager.bulletins.SEND_BY_SMS')} <CostIcon />
              </label>
              {!smsContent ? <small className="form-text text-warning">{t('manager.bulletins.NO_SMS_VERSION')}</small> : null}
              {smsContent ? <small className="form-text text-muted">{t('manager.bulletins.SMS_CREDIT_COST', { credit: creditToUse })}</small> : null}
            </div>
          </Card.Body>
        </Card>
      ) : null}
      <div className="mt-2">
        <Button text="actions.SEND" className="btn btn-primary mr-1" onClick={() => send()} isSubmitting={isSending} disabled={!sendEmail && !sendSms} />
        <Button text="actions.CLOSE" className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())} />
      </div>
    </BaseModal>
  )
}

export default BulletinSendNotificationsModal
